export function clearSessionStorageKeys(keys: readonly string[]) {
  if (typeof window === 'undefined') return;

  keys.forEach(key => {
    sessionStorage.removeItem(key);
  });
}
